var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FieldSelect } from "../../";

import { asNumber, guessType } from "../utils";

var SelectWidget = (_temp2 = _class = function (_Component) {
    _inherits(SelectWidget, _Component);

    function SelectWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, SelectWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.processValue = function (value) {
            var schema = _this.props.schema;


            var nums = new Set(["number", "integer"]);

            // "enum" is a reserved word, so only "type" and "items" can be destructured
            var type = schema.type,
                items = schema.items;


            if (value === "") {
                return undefined;
            } else if (type === "array" && items && nums.has(items.type)) {
                return value.map(asNumber);
            } else if (type === "boolean") {
                return value === "true";
            } else if (type === "number") {
                return asNumber(value);
            }

            // If type is undefined, but an enum is present, try and infer the type from
            // the enum values
            if (schema.enum) {
                if (schema.enum.every(function (x) {
                    return guessType(x) === "number";
                })) {
                    return asNumber(value);
                } else if (schema.enum.every(function (x) {
                    return guessType(x) === "boolean";
                })) {
                    return value === "true";
                }
            }

            return value;
        }, _this.getValue = function (event) {
            var multiple = _this.props.multiple;


            if (multiple) {
                return [].slice.call(event.target.options).filter(function (o) {
                    return o.selected;
                }).map(function (o) {
                    return o.value;
                });
            } else {
                return event.target.value;
            }
        }, _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(_this.props.id, _this.processValue(_this.getValue(event)));
            }
        }, _this.onBlur = function (event) {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.props.id, _this.processValue(_this.getValue(event)));
            }
        }, _this.onChange = function (value, event) {
            _this.props.onChange(_this.processValue(_this.getValue(event)));
        }, _this.getOptions = function () {
            var _this$props = _this.props,
                schema = _this$props.schema,
                multiple = _this$props.multiple,
                placeholder = _this$props.placeholder;
            var _this$props$options = _this.props.options,
                enumOptions = _this$props$options.enumOptions,
                enumDisabled = _this$props$options.enumDisabled;

            // select options

            var options = enumOptions.map(function (_ref, i) {
                var value = _ref.value,
                    label = _ref.label;

                var disabled = enumDisabled && enumDisabled.indexOf(value) !== -1;

                return {
                    value: value,
                    disabled: disabled,
                    label: label
                };
            });

            // add placeholder

            if (!multiple && schema.default === undefined) {

                options.unshift({
                    value: "",
                    label: placeholder
                });
            }

            return options;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * This is a silly limitation in the DOM where option change event values are
     * always retrieved as strings.
     */

    SelectWidget.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            value = _props.value,
            required = _props.required,
            disabled = _props.disabled,
            readonly = _props.readonly,
            multiple = _props.multiple,
            autofocus = _props.autofocus;


        var emptyValue = multiple ? [] : "";

        var options = this.getOptions();

        return React.createElement(FieldSelect, {
            id: id,
            multiple: multiple,
            value: typeof value === "undefined" ? emptyValue : value,
            required: required,
            disabled: disabled || readonly,
            autoFocus: autofocus,
            options: options,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onChange: this.onChange
        });
    };

    return SelectWidget;
}(Component), _class.defaultProps = {
    autofocus: false
}, _temp2);
SelectWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
        enumOptions: PropTypes.array
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    multiple: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
} : {};


export default SelectWidget;